var exports = {
  "wm": "xfd349460--ff2b14--logo",
  "nf": "xfd349460--ff2b14--link",
  "Pf": "xfd349460--ff2b14--label",
};

module.exports = exports;
